export const SHOW_OVERLAY = "@Overlay_ShowOverlay";
export const HIDE_OVERLAY = "@Overlay_HideOverlay";



// WEBPACK FOOTER //
// ./src/app/store/reducers/overlay/ActionsOverlayReducer.ts